// This is used for "micro animations" - general purpose values to give the app a general feel
// By no means is this the rule for building out custom animations for various parts of the application
export const animation = {
    duration: '200ms',
    timing: 'ease',
};
//# sourceMappingURL=animation.js.map